import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteImagesFragment = { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null };

export const CompleteImages = /*#__PURE__*/ gql`
    fragment CompleteImages on Images {
  image32
  image64
  image128
  image256
  imageBase
  original
}
    ` as unknown as DocumentNode<CompleteImagesFragment, unknown>;

        

        
export const useCompleteImagesFragment = (
  input: string | Omit<UseFragmentOptions<CompleteImagesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Images' } };
    return input;
  })();

  return useFragment<CompleteImagesFragment>({
    fragment: CompleteImages,
    fragmentName: 'CompleteImages',
    ...options,
  });
};
  
        